import React, { useEffect } from 'react';
import './new.css';
import { Link } from 'react-router-dom';
import NavBar from '../components/Nav';
import Footer from '../components/footer';
import ScrollTop from '../components/Scrolltop';
import Whatsapp from '../components/Whatsapp';
import Cosection from '../components/Cosections';

export const Taxplanning = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <NavBar />
      <div className="tax-page">
        <div className="tax-notification-container">
          <div className="tax-notification">
            <div className="tax-notification-glow"></div>
            <div className="tax-notification-border-glow"></div>
            <h1 className="tax-notification-title">Tax Planning</h1>
            <Link to="/services" className="tax-notification-body">
              ← Back to Services
            </Link>
          </div>
        </div>

        <div className="tax-content-container">
          <h1 className="tax-section-title">
            Build a Strong Financial Future with Strategic Tax Planning
          </h1>
          <p className="tax-section-description">
            At Litax , we believe smart tax planning is more than
            filing returns—it’s about securing your future. By simplifying
            complex regulations and creating customized strategies, we help
            individuals and businesses reduce liabilities, maximize savings,
            and achieve financial peace of mind.
          </p>

          <h2 className="tax-subheading">What Is Tax Planning?</h2>
          <p className="tax-section-description">
            Tax planning is a proactive approach to managing your income,
            expenses, and investments in ways that legally minimize taxes.
            Whether you’re an individual or a business, effective planning
            ensures you keep more of what you earn while staying compliant with
            IRS requirements.
          </p>

          <h2 className="tax-subheading">Why Tax Planning Matters</h2>
          <ul className="tax-section-description">
            <li>
              <strong>Reduce Liabilities:</strong> Uncover deductions, credits,
              and exemptions that directly lower your taxes.
            </li>
            <li>
              <strong>Eliminate Surprises:</strong> Avoid unexpected bills by
              forecasting tax obligations in advance.
            </li>
            <li>
              <strong>Boost Long-Term Savings:</strong> Align taxes with your
              retirement, education, or wealth-building goals.
            </li>
            <li>
              <strong>Maximize Benefits:</strong> Leverage every opportunity
              within the tax code to keep your finances optimized.
            </li>
          </ul>

          <h2 className="tax-subheading">How We Support You</h2>
          <ol className="tax-section-description">
            <li>
              <strong>Personalized Tax Strategies:</strong> Tailored plans based
              on your income, deductions, and goals.
            </li>
            <li>
              <strong>Retirement Planning:</strong> Make the most of IRAs,
              401(k)s, and other tax-advantaged accounts.
            </li>
            <li>
              <strong>Investment Optimization:</strong> Reduce taxes on
              dividends, capital gains, and passive income.
            </li>
            <li>
              <strong>Business Planning:</strong> Structure your business for
              maximum efficiency and compliance.
            </li>
            <li>
              <strong>Regulation Updates:</strong> Stay ahead of new laws and
              tax-saving opportunities.
            </li>
            <li>
              <strong>Year-Round Guidance:</strong> Ongoing support as your
              financial situation evolves.
            </li>
          </ol>

          <h2 className="tax-subheading">Start Planning Today</h2>
          <p className="tax-section-description">
            Don’t wait until tax season to think about your future. With
            Litax , you’ll have expert guidance, proactive
            strategies, and peace of mind all year long. Contact us today to
            schedule a consultation and start planning smarter.
          </p>
        </div>
      </div>
      <Cosection />
      <Whatsapp />
      <ScrollTop />
      <Footer />
    </div>
  );
};

export default Taxplanning;
